// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"452":"7acb0c0d","864":"17c87333"}[chunkId] + ".css";
};